import { put, takeEvery, call } from 'redux-saga/effects';

import { serializeKeys, deserializeKeys } from '@iso/lib/helpers/keyNormalizer';
import request from '@iso/lib/helpers/httpClient';
import * as CONSTANTS from './constants';
import * as ACTIONS from './actions';
import notify from '@iso/lib/helpers/notify';


function* updateWizardProducer({ userId, payload }) {
  try {
    const data = yield call(request, `/user/${userId}/update/`, 'PATCH', deserializeKeys(payload), true);
    yield put(ACTIONS.updateWizardProducerSuccess(serializeKeys(data)));
  } catch (error) {
    yield put(ACTIONS.updateWizardProducerSuccess(error));
  }
}

function* fetchCompanyDetailByEmail({ email }) {
  try {
    const payload = { ownerEmail: email };
    const data = yield call(request, `/get_company_by_email/`, 'POST', deserializeKeys(payload), true);
    yield put(ACTIONS.fetchCompanyDetailByEmailSuccess(serializeKeys(data)));
  } catch (error) {
    yield put(ACTIONS.fetchCompanyDetailByEmailFail(error));
  }
}

function* createWizardCompany({ payload }) {
  try {
    const data = yield call(request, `/company/`, 'POST', deserializeKeys(payload), true);
    yield put(ACTIONS.createWizardCompanySuccess(serializeKeys(data)));
  } catch (error) {
    if (error && (error?.title || error?.owner_email)) {
      notify('error', 'This email is already linked to an existing company account')
    }
    yield put(ACTIONS.createWizardCompanyFail(error));
  }
}

function* updateWizardCompany({ id, payload }) {
  try {
    const data = yield call(request, `/company/${id}/`, 'PATCH', deserializeKeys(payload), true);
    yield put(ACTIONS.updateWizardCompanySuccess(serializeKeys(data)));
  } catch (error) {
    yield put(ACTIONS.updateWizardCompanyFail(error));
  }
}

export default function* accountWizardSaga() {
  yield takeEvery(CONSTANTS.UPDATE_WIZARD_PRODUCER_REQUEST, updateWizardProducer);
  yield takeEvery(CONSTANTS.FETCH_WIZARD_COMPANY_DETAIL_BY_EMAIL_REQUEST, fetchCompanyDetailByEmail);
  yield takeEvery(CONSTANTS.CREATE_WIZARD_COMPANY_REQUEST, createWizardCompany);
  yield takeEvery(CONSTANTS.UPDATE_WIZARD_COMPANY_REQUEST, updateWizardCompany);
}
